import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { css } from '../../viewer/Menu.previewMapper';

/**
 * We want all the styles applied to the top-level Menu to be available on the inner menu.
 * In the viewer, for every Menu component we generate additional structure for MenuContent
 * this structure inherits the skin and styleId from the main menu component
 * this way, the viewer will run the css mapper for MenuContent with all of the styles applied on the top level menu
 * and will apply the result on the `#portal-${menuId}` selector
 */
export default createComponentPreviewMapperModel({ css });
